module.exports = __webpack_public_path__ + "img/sddq.284c4294.jpg";